import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const gcProgressSchema: Schema = {
  title: 'GC Progress',
  level: 2,
  columns: commonColumns
}
